import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';


const create = async (data: any): Promise<any> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('./chamados', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao criar menssagem.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao criar menssagem.');
    }
};

const get = async (): Promise<any> => {
	await AuthService.verify();

	try{
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get('/chamados', {
			headers: {
				Authorization: `${token}`
			}
		});

		if(response.data){
			return response.data;
		}
	} catch (error) {
		console.log(error);
		return new Error((error as {menssage: string}).menssage || 'Erro ao buscar chamados');
	}
};

export const SupportServices = {
    create,
		get
};